import script from "./ERecordAudio.vue?vue&type=script&lang=ts&setup=true"
export * from "./ERecordAudio.vue?vue&type=script&lang=ts&setup=true"

import "./ERecordAudio.vue?vue&type=style&index=0&id=de5e9dde&scoped=true&lang=css"
/* custom blocks */
import block0 from "./ERecordAudio.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de5e9dde"]])

export default __exports__